const bridge = () =>
  typeof window !== "undefined" ? window.desktopOfflineMenuScanner : null;

const cleanError = (error) => String(error?.message || error || "Menu Scanner access failed.")
  .replace(/^Error invoking remote method '[^']+':\s*(?:Error:\s*)?/i, "")
  .replace(/^Error:\s*/i, "")
  .trim();

export const setOfflineMenuScannerApiAccess = async (enabled) => {
  const api = bridge();
  if (!api?.setApiAccess) {
    throw new Error("Restart the desktop app to initialize Menu Scanner access.");
  }
  try {
    return await api.setApiAccess(enabled === true);
  } catch (error) {
    throw new Error(cleanError(error) || "Menu Scanner access failed.");
  }
};
